import {ReactSVG} from "react-svg";

export const TextFriICon = () => {
    return (
        <ReactSVG src={"/fri-media/logo-fri-text.svg"}></ReactSVG>
    );
};